<template>
  <div class="page-loading" v-show="loading">
    <!--    <template v-if="isHome">-->
    <!--      <div v-if="['phlwin', 'bigwin', 'black'].includes(template)" class="loadingLine-container">-->
    <!--        <img v-if="logo" :src="logo" />-->
    <!--        <div class="loading-line"></div>-->
    <!--      </div>-->
    <!--      <div class="loading-box">-->
    <!--        <img class="rotate" src="/images/rotate.png" />-->
    <!--        <img v-if="logo" class="logo" :src="logo" alt="" />-->
    <!--      </div>-->
    <!--    </template>-->
    <div class="flex-center flex-column">
      <!--      <img class="logo" src="@/assets/img/home/logo.png" v-if="isHome" />-->
      <img class="logo" v-lazy="logoSrc" v-if="isHome && logoSrc" alt="" />
      <custom-loading />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs, useAppStore, useTenantStore } from '@star/stores';
import CustomLoading from '../CustomLoading.vue';
import { useRoute } from 'vue-router';

type Props = {
  loading?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  loading: false,
});

const appStore = useAppStore();
const { isPageLoading, template } = storeToRefs(appStore);
const { tenantInfo, logoSrc } = storeToRefs(useTenantStore());
const route = useRoute();

// const logoSrc = computed(() => {
//   // 取PC LOGO
//   return get(
//     find(tenantInfo.value?.logo_manage, item => item.message_id === 29 && item.pic_addr),
//     'pic_addr'
//   );
// });

const loading = computed(() => {
  return props.loading || isPageLoading.value;
});

const isHome = computed(() => {
  return route.name === 'home';
});
</script>

<style lang="less" scoped>
@keyframes changeright {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes bounce {
  0% {
    transform: scale(1.1);
    filter: blur(0);
  }

  50% {
    transform: scale(0.8);
    filter: blur(1.4);
  }

  100% {
    transform: scale(1.1);
  }
}

@keyframes animationLine {
  0% {
    left: 0;
  }

  50% {
    left: calc(100% - 60px);
  }

  100% {
    left: 0;
  }
}

.page-loading {
  position: fixed;
  z-index: 1000;
  background: var(--theme-backgroud-color);
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &.has-header {
    margin-top: calc(var(--header-height) - 3px);
  }

  &.has-footer {
    margin-bottom: calc(var(--footer-height) - 6px);
  }

  .logo {
    height: 150px;
    margin-bottom: 45px;
  }

  .loadingLine-container {
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 20px;
    padding: 40px;

    img {
      max-width: 600px;
      width: 80%;
      animation: bounce 1.4s ease infinite;
      display: block;
      margin: 0 auto;
    }
  }

  .loading-line {
    width: 450px;
    display: block;
    height: 24px;
    margin: 54px auto;
    border-radius: 30px;
    background-color: #151c26;
    position: relative;
    overflow: hidden;
    z-index: 1;

    &::after {
      content: '';
      height: 24px;
      width: 60px;
      position: absolute;
      left: 0;
      background-color: #f2d861;
      border-radius: 30px;
      animation: animationLine 1.4s infinite ease;
    }
  }

  .loading-box {
    width: 135px;
    height: 135px;
    position: relative;
    background: #262833;
    box-shadow: 0 12px 48px 0 rgb(33 33 55 / 69%);
    border-radius: 12px;
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: calc(100% - 36px);
      height: calc(100% - 36px);
      margin: 0;

      &.rotate {
        position: absolute;
        top: 18px;
        left: 18px;
        animation: changeright 1s linear infinite;
      }

      &.logo {
        width: 55%;
        height: 55%;
        object-fit: contain;
      }
    }
  }
}
</style>
